export interface RowDataTransaction {
  addIndex?: number;
  add?: any[];
  remove?: any[];
  update?: any[];
}
